import React from 'react';
import { ClassAssembly9D2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly9D2026/>;
  };
  
  export default ClassAssemblyPage;